import React, {Fragment, useState, useContext} from 'react';
import {
    Button,
    Typography,
    Snackbar
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import VehiculoForm from './Forms/VehiculoForm';
import PolizaForm from './Forms/PolizaForm';
import ClienteForm from './Forms/ClienteForm';
import SolicitudForm from './Forms/SolicitudForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import axios from 'axios';

import EmisionSuccess from "./EmisionSuccess";
import Loading from "../../../../../components/Loading";
import Alert from '@material-ui/lab/Alert';
import motorbike_white_icon from "../../../../../assets/images/white_motorbike_icon.png";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import AuthContext from "../../../../../context/AuthContext";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";


const steps = ['Póliza', 'Cliente', 'Vehículo', 'Solicitud'];
const {formId, formField} = formModel;


function _renderStepContent(step, applyDiscounts) {
    switch (step) {
        case 0:
            return <PolizaForm formField={formField}/>;
        case 1:
            return <ClienteForm formField={formField}/>;
        case 2:
            return <VehiculoForm
                formField={formField}
            />;
        case 3:
            return <SolicitudForm formField={formField} applyDiscounts={applyDiscounts}/>;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutPage(props) {
    const classes = useStyles();
    const {continueCotizacion, emisionValues, applyDiscounts} = props;
    const [activeStep, setActiveStep] = useState(0);
    const currentValidationSchema = validationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;
    const [emisionResponse, setEmisionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);

    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const {handleModified} = useContext(IndicatorsContext)

    if (continueCotizacion && emisionValues.clientes[0].telefono) {

        for (let emision of emisionValues.clientes) {

            if (emision.telefono.substr(0, 1) === '0') {
                emision.telefono = emision.telefono.substr(1, emision.telefono.length)
            }
            if (emision.telefono.length === 9) {
                emision.codigoArea = (emision.telefono).substr(0, 2)
                emision.telefono = (emision.telefono).substr(2, 7)
            }
            if (emision.telefono.length === 10) {
                emision.codigoArea = (emision.telefono).substr(0, 3)
                emision.telefono = (emision.telefono).substr(3, 7)
            }
            if (emision.telefono.length === 11) {
                emision.codigoArea = (emision.telefono).substr(0, 4)
                emision.telefono = (emision.telefono).substr(4, 7)
            }
        }
    }


    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    const {authToken} = useContext(AuthContext)

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/motovehiculo';
        values.origen = 'affinity';
        values.applyDiscounts = false;

        for (let cliente of values.clientes) {
            if (cliente['personaJuridica'] === '1') {
                cliente['dni'] = cliente['cuit']
                cliente['situacionIva'] = '1'
                cliente['nombre'] = ''
            }
        }

        setFinalValues(values);

        axios.post(url, values, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(res => {
            const data = res.data;
            if (data.officialNumber && typeof data.officialNumber === 'object') {
                data.officialNumber = null;
            }
            setEmisionResponse(data)
            handleModified()
        }).catch(err => {
            console.log(err);
            alert('No se pudo completar la operación, vuelva a cargar la página')
        });

        actions.setSubmitting(false);
        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {
        if (isLastStep) {
            _submitForm(values, actions);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    return (
        <React.Fragment>
            <div className={classes.iconCircle}>
                <img src={motorbike_white_icon} alt="motorbike_icon" style={{width: "40px", height: "auto"}}/>
            </div>
            <div style={{margin: "24px 0"}}>
                <ProgressBar activeStep={activeStep} stepTitles={steps}/>
            </div>
            <Fragment>
                {activeStep === steps.length ? (
                    <Fragment>
                        {(emisionResponse !== null && finalValues !== null)
                            ? <EmisionSuccess finalValues={finalValues} emisionResponse={emisionResponse}
                                              applyDiscounts={applyDiscounts} setActiveStep={setActiveStep}
                                              setEmisionResponse={setEmisionResponse}/>
                            : (
                                <Fragment>
                                    <Typography variant="h5" gutterBottom>
                                        Procesando el pedido. Por favor espere...
                                    </Typography>
                                    <Loading/>
                                    <Typography variant="body1" gutterBottom align="center">
                                        Esto puede demorar hasta 60 segundos.
                                    </Typography>
                                </Fragment>
                            )
                        }
                    </Fragment>
                ) : (
                    <Formik
                        initialValues={continueCotizacion ? emisionValues : formInitialValues}
                        validationSchema={currentValidationSchema}
                        validateOnBlur={false}
                        onSubmit={_handleSubmit}
                    >
                        {({isSubmitting, errors}) => (
                            <Form id={formId}>
                                {_renderStepContent(activeStep, applyDiscounts)}
                                <div className={classes.buttons}>
                                    {activeStep !== 0 && (
                                        <Button onClick={_handleBack} className={classes.buttonBack}
                                                variant="contained">
                                            Atras
                                        </Button>
                                    )}
                                    <div className={classes.buttons}>
                                        <Button
                                            disabled={isSubmitting}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            className={classes.buttonContained}
                                        >
                                            {isLastStep ? 'Emitir' : 'Siguiente'}
                                        </Button>
                                    </div>
                                </div>
                                {isSubmitting && errors?.vehiculo?.inspeccionPrevia?.archivos !== undefined && (
                                    <div>
                                        {handleOpenAlert(errors?.vehiculo?.inspeccionPrevia?.archivos)}
                                    </div>
                                )}
                                {isSubmitting && errors?.clientes !== undefined && (
                                    <div>
                                        {handleOpenAlert("Algunos de los campos ingresados no son válidos, revise nuevamente los clientes ingresados.")}
                                    </div>
                                )}
                            </Form>
                        )}
                    </Formik>
                )}
            </Fragment>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
